export const EMAIL_SPECIAL_SYMBOLS =
  /^[^<>()[\]\\,;:%#^\s@"$&!]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,}))$/;
export const LINKED_IN_URL =
  /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)\/([-a-zA-Z0-9]+)\/*/gm;
